import { Check } from 'lucide-react';
import CategoryDropdown from './CategoryDropdown';
import type { ActivityCategory } from '@/types/activity';

interface ActivityCategorySelectorProps {
  isActive: boolean;
  categories: ActivityCategory[];
  selectedCategoryId: number | null;
  onCategoryChange: (categoryId: number | null) => void;
  onActivate: () => void;
  warning?: string | null;
}

export default function ActivityCategorySelector({
  isActive,
  categories,
  selectedCategoryId,
  onCategoryChange,
  onActivate,
  warning,
}: ActivityCategorySelectorProps) {
  const selectedCategory = categories.find(
    (c) => parseInt(c.id, 10) === selectedCategoryId
  );

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onActivate}
          className="w-5 h-5 flex items-center justify-center cursor-pointer"
        >
          {isActive ? (
            <Check className="w-4 h-4 text-admin-accent-blue" />
          ) : (
            <span className="w-4 h-4 rounded-sm border border-admin-slate-300/30 hover:border-admin-slate-300/60 transition-colors" />
          )}
        </button>
        <span className="text-sm font-medium text-admin-slate-400">Select Category with Image</span>
      </div>

      <div className="ml-7">
        <CategoryDropdown
          categories={categories}
          selectedCategoryId={selectedCategoryId}
          onSelect={onCategoryChange}
        />
        {selectedCategory && !selectedCategory.imageName && (
          <p className="text-xs text-admin-slate-600 mt-1">
            This category has no image assigned.
          </p>
        )}
      </div>

      {warning && !isActive && (
        <p className="text-xs text-amber-400 ml-7">{warning}</p>
      )}
    </div>
  );
}
